import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { Form } from 'react-form';

import {
  ModalContent,
  ModalNavigation,
  ModalScrollable,
  ModalWrapper,
  PressStud,
  TextAreaField
} from 'v1/components/shared';

import { displayAlert } from 'store/v1/ui/ui.actions.js';

import { get, uniq } from 'lodash';
import { callsheets } from '../../../../../store/v1/callsheets/callsheets.hooks.connected';

class CallsheetTeamNoteModal extends Component {
  constructor(props) {
    super(props);

    const teamMember = get(props.ui, 'data.teamMember');
    const callsheetID = get(props.ui, 'data.callsheetID');
    const legacyTeamMembers = get(props.ui, 'data.teamMembers', []);
    const teamMemberIdsFromUI = get(props.ui, 'data.teamMemberIds');
    const teamMemberIds = uniq(
      (
        teamMemberIdsFromUI ||
        legacyTeamMembers.map(member => get(member, 'id'))
      ).filter(memberId => memberId != null)
    );

    this.state = {
      teamMember,
      teamMemberIds,
      callsheetID
    };
  }

  handleSubmit = values => {
    const teamMemberId = get(this.state, 'teamMember.id');
    const note = values.note ?? '';
    const teamMemberIds = uniq(
      (this.state.teamMemberIds?.length > 0
        ? this.state.teamMemberIds
        : [teamMemberId]
      ).filter(memberId => memberId != null)
    );

    const teamMembersPayload = teamMemberIds.map(memberId => {
      if (String(memberId) === String(teamMemberId)) {
        return { id: memberId, note };
      }
      return { id: memberId };
    });

    if (
      teamMemberId == null ||
      this.state.callsheetID == null ||
      !teamMembersPayload.length
    ) {
      this.props.displayAlert('error', 'Could not update note');
      return;
    }

    this.props.updateMutation.mutate(
      {
        id: this.state.callsheetID,
        team_members: teamMembersPayload
      },
      {
        onSuccess: () => {
          this.props.displayAlert('success', 'Note added');
          this.props.onRequestClose();
        },
        onError: error => {
          this.props.displayAlert('error', error);
        }
      }
    );
  };

  render() {
    const { onRequestClose } = this.props;
    const { teamMember } = this.state;
    const teamMemberName = teamMember?.display_name || 'this team member';

    return (
      <ModalWrapper size="S">
        <ModalContent>
          <ModalScrollable>
            <h3>Attach a personal note for {teamMemberName}</h3>
            <p>
              This note will be visible on their callsheet and on the email they
              will receive
            </p>
            <Form
              onSubmit={this.handleSubmit}
              defaultValues={{
                note: teamMember?.note ?? ''
              }}
              getApi={api => {
                this.formApi = api;
              }}
            >
              {formApi => (
                <form onSubmit={formApi.submitForm}>
                  <TextAreaField
                    field="note"
                    placeholder="Add a personal note to an individual recipient’s callsheet"
                    rows={3}
                  />
                </form>
              )}
            </Form>
          </ModalScrollable>
          <ModalNavigation>
            <PressStud
              label="Cancel"
              appearance="silent"
              action={onRequestClose}
            />
            <PressStud
              label="Save"
              appearance="primary"
              isLoading={this.props.updateMutation.isLoading}
              action={() => this.formApi.submitForm()}
            />
          </ModalNavigation>
        </ModalContent>
      </ModalWrapper>
    );
  }
}

function mapStateToProps({ events, ui }) {
  return { events, ui };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ displayAlert }, dispatch);
}

const withQueries = Component =>
  function Wrapper(props) {
    const updateMutation = callsheets.useUpdateMutation();

    return <Component {...props} updateMutation={updateMutation} />;
  };

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withQueries(CallsheetTeamNoteModal))
);
